var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { spenttimeDebug as debug } from './debug';
import { HIT_ACTION_NAME } from '../constants/index';
import { isDotConfigured } from './dot';
/**
 * Object with common data to send in hit
 */
var commonHitData = {
    action: HIT_ACTION_NAME,
};
export var getHitData = function (data) {
    return __assign(__assign({}, commonHitData), data);
};
/**
 * Saves common data for hit
 * @param data Object with data to hit
 */
export var saveHitData = function (data) {
    commonHitData = __assign(__assign({}, commonHitData), data);
};
/**
 * Sends hit with data to the server
 * @param data Object with data to hit
 */
export var sendHit = function (data) {
    var finalHitData = getHitData(data);
    if (isDotConfigured()) {
        window.DOT.hit('event', { d: __assign({}, finalHitData) });
        debug(__assign({ message: '[ HIT ] Hit was sent:' }, finalHitData));
    }
};
